import { match } from 'ts-pattern'
import { Hex } from 'viem'
import { NetworkId } from '@/types/network'

export function getCEXFundBalanceAddress(chainId: NetworkId) {
	const address = match(chainId)
		// Spicy
		.with(88882, () => '0x6a690046E8ea47d8c6d1d1F13146Ec8e7237dCB2')
		// Staging
		.with(88883, () => '0x6a690046E8ea47d8c6d1d1F13146Ec8e7237dCB2')
		// Mainnet
		.with(88888, () => '0x0ECAB88E26f7eA29D0DcB4aBcF060A5Ae09a1C2B')
		.exhaustive()

	return address as Hex
}
